import { BUTTON_SCROLLING_MODAL_BUTTON_VIEW } from './types';

export const triggerButtonScrollingModalIsViewed = (buttonNumber, buttonText) => ({
  type: BUTTON_SCROLLING_MODAL_BUTTON_VIEW,
  buttonNumber,
  buttonText,
});
